import { Injectable } from '@angular/core';
import { IQRCodeScaner } from '../_interface/IQRCodeScanner';
import { CrossAppMessagingService } from './crossApp-messaging.service';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class NativeQRCodeScanerService implements IQRCodeScaner {

  private _isEnabled = true;
  private result$?: Subject<string>;

  constructor(
    private crossAppMessaging: CrossAppMessagingService,
    private translate: TranslateService,
  ) { }

  enable(): void {
    this._isEnabled = true;
  }

  disable(): void {
    this._isEnabled = false;
  }

  get isEnabled(): boolean {
    return this._isEnabled;
  }

  setBusy(busy: boolean): void {
    // The native shell owns the camera UI, so it renders its own busy indicator.
    // i18n lives in Angular, so we pass the already-translated labels along.
    // Unknown actions are ignored by older shells, so this stays backward-compatible.
    this.crossAppMessaging.sendRawMessage({
      action: "qrScaner_busy",
      data: {
        busy,
        detected: this.translate.instant('qrScanDetected'),
        connecting: this.translate.instant('qrScanConnecting'),
      }
    }, false);
  }

  stop(): void {
    var msg = {
      action: "qrScaner_close"
    };
    this.result$?.complete();
    this.crossAppMessaging.sendRawMessage(msg, false);
  }

  start() {
    this.result$ = new Subject<string>();
    var msg = {
      action: "qrScaner_scan",
      // The native scan window shows this hint; i18n is resolved here in Angular.
      data: { hint: this.translate.instant('qrScanHint') }
    };

    this.crossAppMessaging.sendRawMessage(msg, false);

    this.crossAppMessaging.onMessage("qrScaner_scaned").subscribe((msg) => {
      var code = this.extractCode(msg);

      this.result$?.next(code);
    });

    // Native popup dismissed (e.g. user tapped ✕) → stop waiting on a scan.
    this.crossAppMessaging.onMessage("qrScaner_closed").subscribe(() => {
      this.result$?.complete();
    });

    return this.result$;
  }

  extractCode(data: string): string {
    var start = data.lastIndexOf('/') + 1;
    var end: number | undefined = data.lastIndexOf("?");
    if (end == -1) {
      end = undefined;
    }
    return data.substring(start, end);
  }

}
